import React, { Fragment, useEffect } from 'react';
import { Typography, Card, Space, Row, Col, Avatar, Checkbox } from 'antd';
import { getPublicSiteImageSrc } from 'Client/common/utils/AppUtils';


const CardsTwo = ({ handleCheckboxSelection, interestedLOBs }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Define a reusable Card component
  const LOBCard = ({ imgSrc, altText, label, value, index }) => (
    <Col xs={12} sm={12} md={6} lg={8}>
      <Card
        className="checkbox-card"
        bodyStyle={{
          height: "inherit"
        }}
      >
        <Row style={{height:"inherit"}} justify="space-around">
          <Col offset={2} span={12}>
            <img src={getPublicSiteImageSrc(imgSrc)} alt={altText} className="qna_image" aria-hidden="true" />
          </Col>
          <Col span={24}>
            <Checkbox 
              value={value}
              aria-describedby={`lob-desc-${index}`}
              role="checkbox"
            >
              <span className='qna-value' id={`lob-desc-${index}`}>{label}</span>
            </Checkbox>
          </Col>
        </Row>
      </Card>
    </Col>
  );

  // Data for each card
  const cardData = [
    {
      imgSrc: 'small-group.svg',
      altText: 'smallGroup',
      value: 'Small Group',
      label: 'Small Group',
    },
    {
      imgSrc: 'large-group.svg',
      altText: 'Avatar',
      value: 'Large Group',
      label: 'Large Group',
    },
    {
      imgSrc: 'all-business.svg',
      altText: 'allMarkets',
      value: 'All Markets',
      label: 'All Markets',
    },
  ];

  return (
    <Fragment>
      <div>
        <div className="ant-result-title">
          <Fragment>
            <Typography.Title level={2} className="cards-heading">
              <Space>
                <Avatar 
                  style={{ backgroundColor: '#074079', size: 'large' }} 
                  size={{ xs: 32, sm: 32, md: 36, lg: 36, xl: 36, xxl: 36}}
                  aria-label="Step 2"
                >
                  2
                </Avatar>
                <span className="avatar-text" id="market-segments-heading">What market segments do you sell?</span>
              </Space>
            </Typography.Title>
          </Fragment>
        </div>
        <Checkbox.Group 
          name="interestedLOBs" 
          value={interestedLOBs}
          onChange={handleCheckboxSelection}
          role="group"
          aria-labelledby="market-segments-heading"
        >
          <Row gutter={[{xs: 32, sm: 32, md: 64, lg: 16, xl: 16}, 16]} justify="space-around">
            {
              cardData.map((card, index) => {
                return (
                  <LOBCard
                    key={index}
                    index={index}
                    imgSrc={card.imgSrc}
                    altText={card.altText}
                    label={card.label}
                    value={card.value}
                  />
                )
              })
            }
          </Row>
        </Checkbox.Group>
      </div>
    </Fragment>
  );
};

export default CardsTwo;
